module.exports = __webpack_public_path__ + "staticVue/img/login-bg.5f146ac8.png";